<script>
import { mapState } from 'vuex';
import request from '@/services/request';
import Iframe from './Iframe.vue';
import DonationFeed from './DonationFeed.vue';

export default {
  name: 'DonationFeedWidget',

  components: {
    Iframe,
    DonationFeed
  },

  props: {
    campaignSlug: {
      type: String,
      required: false
    }
  },

  data() {
    return {
      campaignSettings: null,
      campaignId: null
    };
  },

  computed: {
    ...mapState(['orgId']),
    ...mapState('publicOrgSettings', ['settings']),
    ...mapState('campaign', {
      campaign: (state) => state
    }),

    showFeed() {
      if (!this.campaignSlug) {
        return true; // Show default feed if no campaign specified
      }
      return !!this.campaignSettings?.id;
    },

    finalCampaignId() {
      if (this.campaignId) {
        return this.campaignId;
      }
      return this.campaign?.id;
    }
  },

  async mounted() {
    // If no campaign slug is passed, use default campaign settings
    if (!this.campaignSlug) {
      this.campaignSettings = this.campaign?.checkoutSettings || this.settings;
      return;
    }

    try {
      const { data: campaign, error } = await request.get(`/public/campaign/${this.orgId}/${this.campaignSlug}`);
      if (error) {
        console.error('Error fetching campaign', error);
        return;
      }

      this.campaignSettings = campaign?.checkoutSettings;
      this.campaignId = campaign?.id;
    } catch (err) {
      console.error('Error fetching campaign settings:', err);
    }
  }
};
</script>

<template>
  <div class="donation-feed-widget-frame">
    <Iframe v-if="showFeed">
      <donation-feed :campaign-id="finalCampaignId" :campaign-settings="campaignSettings" />
    </Iframe>
  </div>
</template>
